export default class OpenTopicsMenu {
  constructor(context) {
    this.context = context;
  }

  run(params) {
    this.context.analytics.track('Topics Menu Opened', params);
  }
}
